export class MenuItems{
    
    aliasName: string;

    customMenuItem: boolean;

    isCustomMenuItem: boolean;

    position: number;

    realName: string;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/menu-items.ts